/**
 * Computes the sort payload to send to applyFilterHandler.
 *
 * [FIN-9877] If operator is empty (user selected the default "Sort by" option),
 * returns { sort: null } to clear the sort instead of sending an empty operator
 * string that the backend cannot handle.
 *
 * @param {Object} selectedSort - { columnName: string, operator: string }
 * @returns {Object} - { sort: null } or { sort: { columnName, operator } }
 */
export const buildSortPayload = (selectedSort) => {
  const filterObj = { ...selectedSort };

  // Map partyId to primaryPartyKey for backend compatibility
  if (selectedSort.columnName === 'partyId') {
    filterObj.columnName = 'primaryPartyKey';
  }

  // If operator is empty (user selected "Sort by" default), clear sort
  if (!filterObj.operator) {
    return { sort: null };
  }

  return { sort: filterObj };
};
